import { CommunityIcon, DialogIcon, PeopleIcon } from 'components/Icons';
import AssembleiaIcon from 'components/Icons/AssembleiaIcon';
import { ITopBarMenuItem } from 'components/TopBar/TopBarMenuItem';
import { ITopBarSubMenuItem } from 'components/TopBar/TopBarSubMenuItem';
import { TopBarMenuAcessoRapido } from 'enuns/TopBarMenuAcessoRapido';
import { TFunction } from 'i18next';
import { AssembleiaAssessorRoutePath, ConvocadosAssessorRoutePath, MensagensAssessorRoutePath, RelatorioPresentesRoutePath } from 'library/Routes';
import { IAuthUserPerfil } from 'store/modules/auth/IAuthUserPerfil';

export const getAcessoRapido = (t: TFunction, perfil: IAuthUserPerfil, currPage: TopBarMenuAcessoRapido, strEventoId: string): ITopBarMenuItem[] => {
  const menus: ITopBarMenuItem[] = [];
  const subMenu: ITopBarSubMenuItem[] = [];

  if (currPage !== TopBarMenuAcessoRapido.Assembleias && perfil.assessorRoute.assembleias.ver) {
    subMenu.push({
      label: t(`SubMenus.assembleia`),
      path: AssembleiaAssessorRoutePath.replace(':id', `${strEventoId}`).split(':type').join('pre'),
      icon: AssembleiaIcon,
    })
  }

  if (currPage !== TopBarMenuAcessoRapido.Convocados && perfil.assessorRoute.convocados.view) {
    subMenu.push({
      label: t(`SubMenus.convocados`),
      path: ConvocadosAssessorRoutePath.replace(':id', `${strEventoId}`),
      icon: CommunityIcon,
    })
  }

  if (currPage !== TopBarMenuAcessoRapido.Mensagens && perfil.assessorRoute.duvidasSugestoes.ver) {
    subMenu.push({
      label: t(`SubMenus.mensagens`),
      path: MensagensAssessorRoutePath.replace(':idEvento', `${strEventoId}`),
      icon: DialogIcon,
    })
  }

  if (currPage !== TopBarMenuAcessoRapido.Presentes && perfil.assessorRoute.assembleias.participantes.verTotal) {
    subMenu.push({
      label: t(`SubMenus.presentes`),
      path: RelatorioPresentesRoutePath.replace(':idAssembleia', `${strEventoId}`),
      icon: PeopleIcon,
    })
  }

  // if (currPage !== TopBarMenuAcessoRapido.Quorum && perfil.assessorRoute.quorum.ver) {
  //   subMenu.push({
  //     label: t(`SubMenus.quorum`),
  //     path: QuorumRoutePath.replace(':idAssembleia', `${strEventoId}`),
  //     icon: CommunityIcon,
  //   })
  // }

  menus.push({
    label: t(`SubMenus.acessoRapido`),
    subItems: subMenu,
  });

  return menus;
}